var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video-container",
      attrs: {
        "data-url": _vm.url,
        "data-thumbnailUrl": _vm.thumbnailUrl,
        "data-status": _vm.status,
        "data-attachmentId": _vm.attachmentId,
        "data-duration": _vm.duration,
        "data-filename": _vm.filename,
      },
    },
    [
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.env === "web",
              expression: "env === 'web'",
            },
          ],
          style: _vm.videoWarpStyle,
        },
        [
          _c("video", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showCover && _vm.status == "ProcessSuccess",
                expression: "!showCover && status == 'ProcessSuccess'",
              },
            ],
            ref: "video",
            staticClass: "video-player",
            attrs: {
              "x5-video-player-type": "h5-page",
              controls: "",
              preload: _vm.env === "web" ? "auto" : "none",
              controlslist: "nodownload noremoteplayback",
              disablePictureInPicture: "",
              src: _vm.url,
              poster: _vm.thumbnailUrl,
            },
            on: { play: _vm.onPlay, pause: _vm.onStop, ended: _vm.onStop },
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showCover,
                expression: "showCover",
              },
            ],
            staticClass: "video-player",
            attrs: { src: _vm.thumbnailUrl, alt: "封面图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.enableJsbridge && _vm.env === "app",
              expression: "!enableJsbridge && env === 'app'",
            },
          ],
          attrs: { href: _vm.videoScheme },
        },
        [
          _c("img", {
            staticClass: "video-player",
            attrs: { src: _vm.thumbnailUrl, alt: "视频封面图" },
          }),
          _vm._v(" "),
          _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isPlaying,
                  expression: "!isPlaying",
                },
              ],
              staticClass: "play-icon",
            },
            [
              _c("svg-icon", {
                staticClass: "paly-icon-svg",
                attrs: { name: "play_video" },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.enableJsbridge && _vm.env === "app",
              expression: "enableJsbridge && env === 'app'",
            },
          ],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handlePlay.apply(null, arguments)
            },
          },
        },
        [
          _c("img", {
            staticClass: "video-player",
            attrs: { src: _vm.thumbnailUrl, alt: "视频封面图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.enableJsbridge && !_vm.isPlaying,
              expression: "enableJsbridge && !isPlaying",
            },
          ],
          staticClass: "play-icon",
          on: { click: _vm.handlePlay },
        },
        [
          _c("svg-icon", {
            staticClass: "paly-icon-svg",
            attrs: { name: "play_video" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isPlaying && _vm.duration && _vm.durationText,
              expression: "!isPlaying && duration && durationText",
            },
          ],
          class: _vm.env === "web" ? "durationWeb" : "durationApp",
        },
        [_c("div", [_vm._v("视频时长：" + _vm._s(_vm.durationText))])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }